import { UserList } from '../data/interfaces/users-list';
import {
  collection,
  getDocs,
  orderBy,
  limit,
  query,
  startAfter,
  where,
  QueryConstraint,
  getCountFromServer,
  QueryDocumentSnapshot,
  DocumentData
} from '@firebase/firestore';
import { apiAxios, firestoreDb } from '../../../constants';

export async function searchUsersBy(
  prop: string,
  searchText: string,
  itemsPerPage: number,
  next?: QueryDocumentSnapshot<DocumentData>
): Promise<{
  totalSize: number;
  users: UserList[];
}> {
  searchText = searchText.trim();

  const sizeQuery = query(
    collection(firestoreDb, 'users'),
    where(prop, '>=', searchText),
    where(prop, '<=', searchText + `~`)
  );

  const size = (await getCountFromServer(sizeQuery)).data().count;

  const queryConstraint: QueryConstraint[] = [
    orderBy(prop),
    where(prop, '>=', searchText),
    where(prop, '<=', searchText + `~`),
    limit(itemsPerPage)
  ];
  if (next) queryConstraint.push(startAfter(next));

  const q = query(collection(firestoreDb, 'users'), ...queryConstraint);
  const snapshot = await getDocs(q);

  const users = await Promise.all(
    snapshot.docs.map(async (doc) => {
      const user = doc.data() as UserList;
      let referralCode = '';

      if (user.uid) {
        const codeQuery = query(
          collection(firestoreDb, `users/${user.uid}/referrals`)
        );
        const referralDoc = (await getDocs(codeQuery)).docs[0];
        referralCode = referralDoc?.data()?.referralCode || '';
      }

      return {
        ...user,
        referralCode,
        doc
      } as UserList;
    })
  );

  return {
    totalSize: size,
    users
  };
}

export async function searchUsersByPhone(
  phoneNumber: string,
  rowsPerPage: number = 20,
  page: number = 0
): Promise<{
  totalSize: number;
  users: any[];
}> {
  try {
    const resp = await apiAxios.get('searchUsersByPhoneNumber', {
      params: { phoneNumber, limit: rowsPerPage, page }
    });

    return {
      totalSize: resp?.data?.data?.totalCount ?? 0,
      users: resp?.data?.data?.users ?? []
    };
  } catch (_error) {
    return { totalSize: 0, users: [] };
  }
}

export async function searchUsersByReferral(
  query: string,
  rowsPerPage: number,
  page: number = 0
): Promise<{
  totalSize: number;
  users: any[];
}> {
  try {
    const resp = await apiAxios.get('searchUsersByReferralCode', {
      params: {
        referralCode: query,
        limit: rowsPerPage,
        page
      }
    });

    return {
      totalSize: resp?.data?.data?.totalCount ?? 0,
      users: resp?.data?.data?.users ?? []
    };
  } catch (_error) {
    return {
      totalSize: 0,
      users: []
    };
  }
}
